<template>
<div>
  <div v-if="$hasFeature('wallet')" class="cornerfilter">
  <router-link :to="{ name: 'Wallet'}">
  Wallet
  </router-link>
</div>
  <div class="card-header">
    <div class="card-header-col card-col w150">
      Invoice Id
    </div>
    <div class="card-header-col card-col w150">
      Status
    </div>
    <div class="card-header-col card-col w150">
      Invoice Created
    </div>
    <div class="card-header-col card-col w200">
      Invoice Amount
    </div>
    <div class="card-header-col card-col order-actions">

    </div>
    <div class="card-header-col card-col w30">

    </div>
  </div>
</div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
@import "~@common/styles-transporter/settings";
.cornerfilter {
  text-align: right;
  margin-bottom: 20px;
  z-index: 9;
  position: relative;
  a {
    color: #234357;
    font-family:$fontSemibold;
    font-size: 1.2rem;
  }
}
</style>
